import type { AlertCircle, CheckCircle, Info, XCircle } from '@chain-zen/ui'
import React from 'react'

const getColorClasses = (color: string) => {
  switch (color) {
    case 'orange':
      return {
        bg: 'bg-orange-100 dark:bg-orange-900/16',
        border: 'border-orange-200 dark:border-orange-800',
        icon: 'text-orange-800 dark:text-orange-200',
        title: 'text-orange-800 dark:text-orange-200'
      }
    case 'red':
      return {
        bg: 'bg-red-100 dark:bg-red-900/16',
        border: 'border-red-200 dark:border-red-800',
        icon: 'text-red-800 dark:text-red-200',
        title: 'text-red-800 dark:text-red-200'
      }
    case 'purple':
      return {
        bg: 'bg-purple-100 dark:bg-purple-900/16',
        border: 'border-purple-200 dark:border-purple-800',
        icon: 'text-purple-800 dark:text-purple-200',
        title: 'text-purple-800 dark:text-purple-200'
      }
    default:
      return {
        bg: 'bg-gray-100 dark:bg-gray-900/16',
        border: 'border-gray-200 dark:border-gray-800',
        icon: 'text-gray-800 dark:text-gray-200',
        title: 'text-gray-800 dark:text-gray-200'
      }
  }
}

/**
 * AlertMessage displays an alert message with an icon and a title.
 */
export const AlertMessage = (props: {
  alertIcon: typeof AlertCircle | typeof CheckCircle | typeof Info | typeof XCircle
  alertMessage: string | React.ReactNode
  alertTitle: string
  textAndIconColor: string
}) => {
  const { alertMessage, alertIcon: AlertIcon, alertTitle, textAndIconColor } = props

  const colorClasses = getColorClasses(textAndIconColor)

  return (
    <div className="flex items-start gap-3">
      <div
        className={`flex items-center justify-center w-6 h-6 rounded-full border ${colorClasses.bg} ${colorClasses.border} p-1`}
      >
        <AlertIcon className={`h-4 w-4 ${colorClasses.icon}`} />
      </div>
      <div className="flex flex-col gap-1">
        <div className={`font-medium ${colorClasses.title}`}>{alertTitle}</div>
        <div className="text-sm text-gray-600 dark:text-gray-400">{alertMessage}</div>
      </div>
    </div>
  )
}
